import Vue from 'vue'
import App from './App.vue'
import router from './router/routers'
import store from './store'

import './router/index' // permission control

import Cookies from 'js-cookie'
import 'normalize.css/normalize.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import './single-spa-config.js'

import { getDicts } from "@/api/system/dict/data";

import { parseTime, selectDictLabel } from "@/utils/system";

import './assets/css/base.css'
import './assets/scss/element-variables.scss'
import './assets/css/light.css'

import './assets/icons' // icon

Vue.prototype.getDicts = getDicts
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.parseTime = parseTime
Vue.config.productionTip = false
// 在入口 main.js 中，创建一个 bus 总线,这样全局都可以使用
Vue.prototype.$bus = new Vue()

Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}

Vue.prototype.msgWarn = function (msg) {
  this.$message.warning(msg);
}

Vue.use(ElementUI);

let cVue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
